import { create } from "zustand";
import { assetGenerationSteps } from "../context/ProjectProvider/constants";
import { Steps } from "@/components/ProgressiveStepBar/types";

export interface StepsType {
  assetGeneration: Steps[];
}

interface StepState {
  currentStep: number;
  currentTimeStamp: number;
  steps: StepsType;

  setCurrentStep: (step: number) => void;
  onNextStep: () => void;
  onPreviousStep: () => void;
  setSteps: (steps: StepsType) => void;
  resetStep: () => void;
}

export const useStepStore = create<StepState>((set) => ({
  currentStep: 1,
  currentTimeStamp: Date.now(),
  steps: {
    assetGeneration: assetGenerationSteps,
  },

  setCurrentStep: (step) => set({ currentStep: step }),
  onNextStep: () =>
    set((state) => ({
      currentStep: state.currentStep + 1,
      currentTimeStamp: Date.now(),
    })),
  onPreviousStep: () =>
    set((state) => ({
      currentStep: state.currentStep - 1,
      currentTimeStamp: Date.now(),
    })),
  setSteps: (steps) => set({ steps }),
  resetStep: () => set({ currentStep: 1, currentTimeStamp: Date.now() }),
}));
